import React from 'react';

const Skeleton = ({ width = '100%', height = 16, style }) => (
  <div className="fd-skeleton" style={{ width, height, ...style }} />
);

export default Skeleton;
